import { Component, Input } from '@angular/core';
import { AnalyticEvents } from '@app/enums';
import { AnalyticService } from '@app/services';

@Component({
    selector: 'app-upsell-card',
    templateUrl: './upsell-card.component.html',
    styleUrls: ['./upsell-card.component.scss'],
})
export class UpsellCardComponent {
    @Input() header = '';
    @Input() tagline = '';
    @Input() taglineImgSrc = '';
    @Input() description = '';
    @Input() src = '';
    @Input() CTAText = '';
    @Input() moduleName = '';
    @Input()
    CTAEvent!: AnalyticEvents;
    @Input()
    learnMoreEvent!: AnalyticEvents;
    @Input() externalURL = '';

    constructor(private analyticsService: AnalyticService) {}

    trackButtonEvent(): void {
        if (!this.CTAEvent) {
            return;
        }

        this.analyticsService.trackEvent(this.CTAEvent);
    }

    trackLearnMoreEvent(): void {
        if (!this.learnMoreEvent) {
            return;
        }

        this.analyticsService.trackEvent(this.learnMoreEvent);
    }
}
